export const SQUATTING = 'squatting'
export const CHUCKLING = 'chuckling'
export const SMIRKING = 'smirking'
